import React from 'react';

import { translate } from '~l10n/client/translate';

interface SpecificStudentScoreCellProps {
  score: {
    currentScore: number;
    maxScore: number;
    isAbsent: boolean;
    percentage?: number;
  };
}

export const SpecificStudentScoreCell = (
  props: SpecificStudentScoreCellProps
) => {
  return (
    <div>
      {props.score.isAbsent ? (
        <div className="w-[96px] rounded-1 relative justify-center px-2 py-3 bg-grey-50 text-sm text-green-900 overflow-hidden">
          {translate('Absent')}
        </div>
      ) : (
        <div className="w-[96px] rounded-1 relative justify-center px-2 py-3 bg-green-50 text-sm text-green-900 overflow-hidden">
          {/* Gradient fill based on score percentage */}
          <div
            className="absolute inset-0 bg-green-200 origin-left"
            style={{ transform: `scaleX(${props.score.percentage ?? 0})` }}
          />
          <span className="relative z-10">
            {translate('{0} of {1}').format(
              props.score.currentScore,
              props.score.maxScore
            )}
          </span>
        </div>
      )}
    </div>
  );
};
